import { IoBookOutline, IoCheckmarkCircleOutline, IoStatsChartOutline, IoTrophyOutline } from 'react-icons/io5';
import './ProgressStats.css';

const ProgressStats = ({ stats, selectedReaders }) => {
  const {
    totalChapters,
    uniqueChaptersRead,
    percentComplete,
    oldTestamentRead,
    newTestamentRead,
    totalReports
  } = stats;

  const oldTestamentTotal = 929; // Total OT chapters
  const newTestamentTotal = 260; // Total NT chapters

  const formatReaderNames = () => {
    if (selectedReaders.length === 1) {
      return selectedReaders[0].name;
    } else if (selectedReaders.length <= 3) {
      return selectedReaders.map(r => r.name).join(', ');
    } else {
      return `${selectedReaders.length} readers`;
    }
  };

  return (
    <div className="progress-stats">
      <div className="stats-header">
        <h3>Progress for {formatReaderNames()}</h3>
      </div>

      <div className="stats-grid">
        {/* Overall Progress */}
        <div className="stat-card primary">
          <div className="stat-icon">
            <IoTrophyOutline size={32} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{percentComplete}%</div>
            <div className="stat-label">Complete</div>
            <div className="stat-detail">
              {uniqueChaptersRead} of {totalChapters} chapters
            </div>
          </div>
          <div className="stat-progress">
            <div
              className="progress-bar"
              style={{ width: `${percentComplete}%` }}
            />
          </div>
        </div>

        {/* Total Reports */}
        <div className="stat-card">
          <div className="stat-icon">
            <IoStatsChartOutline size={24} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{totalReports.toLocaleString()}</div>
            <div className="stat-label">Chapters logged</div>
            <div className="stat-detail">
              {totalReports - (stats.rawChapters || 0) === uniqueChaptersRead
                ? 'No identified re-reads'
                : `${totalReports - (stats.rawChapters || 0) - uniqueChaptersRead} re-reads`
              }
            </div>
          </div>
        </div>

        {stats.rawChapters > 0 && <p>{stats.rawChapters} chapters logged by count are included above. Bible coverage and books finished use identified chapters.</p>}

        {/* Old Testament */}
        <div className="stat-card testament-old">
          <div className="stat-icon">
            <IoBookOutline size={24} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{oldTestamentRead}</div>
            <div className="stat-label">Old Testament</div>
            <div className="stat-detail">
              {Math.round((oldTestamentRead / oldTestamentTotal) * 100)}% of {oldTestamentTotal}
            </div>
          </div>
          <div className="stat-progress">
            <div
              className="progress-bar old-testament"
              style={{ width: `${(oldTestamentRead / oldTestamentTotal) * 100}%` }}
            />
          </div>
        </div>

        {/* New Testament */}
        <div className="stat-card testament-new">
          <div className="stat-icon">
            <IoCheckmarkCircleOutline size={24} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{newTestamentRead}</div>
            <div className="stat-label">New Testament</div>
            <div className="stat-detail">
              {Math.round((newTestamentRead / newTestamentTotal) * 100)}% of {newTestamentTotal}
            </div>
          </div>
          <div className="stat-progress">
            <div
              className="progress-bar new-testament"
              style={{ width: `${(newTestamentRead / newTestamentTotal) * 100}%` }}
            />
          </div>
        </div>
      </div>

      {/* Achievement Messages */}
      {percentComplete === 100 && (
        <div className="achievement-message complete">
          🎉 Congratulations! You've completed the entire Bible!
        </div>
      )}
      {percentComplete >= 50 && percentComplete < 100 && (
        <div className="achievement-message halfway">
          🌟 Amazing progress! You're more than halfway through the Bible!
        </div>
      )}
      {oldTestamentRead === oldTestamentTotal && newTestamentRead < newTestamentTotal && (
        <div className="achievement-message testament">
          📜 Old Testament Complete! Now on to the New Testament!
        </div>
      )}
      {newTestamentRead === newTestamentTotal && oldTestamentRead < oldTestamentTotal && (
        <div className="achievement-message testament">
          ✝️ New Testament Complete! Keep going with the Old Testament!
        </div>
      )}
    </div>
  );
};

export default ProgressStats;
